'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _axiosM = require('@beastshop/axios-m');

var _axiosM2 = _interopRequireDefault(_axiosM);

var _axios = require('@beastshop/axios');

var _axios2 = _interopRequireDefault(_axios);

var _browser = require('@beastshop/browser');

var _jsCookie = require('js-cookie');

var _jsCookie2 = _interopRequireDefault(_jsCookie);

var _util = require('../lib/util');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

miniSetBeastId();

exports.default = function (options) {
  return new _promise2.default(function (resolve) {
    _util.adapter.invoke(resolve);
  }).then(function () {
    if (_util.adapter.env === 'miniprogram') {
      return request(options);
    } else {
      if ((0, _browser.android)()) {
        var url = options.url;
        options.url = url.replace('/app', 'app'); // 兼容安卓
      }
      console.log('other:', options);
      return (0, _axiosM2.default)(options);
    }
  });
};

var HEADER_AUTHORIZATION = 'Authorization';
var HEADER_BEAST_ID = '+TBS-Id';
var HEADER_DEVICE_ID = 'Device-Id';
var HEADER_PLATFORM = 'Platform';
var HEADER_TBS_CLIENT = 'TBS-Client';
var HEADER_TBS_CHANNEL = 'TBS-Channel';
var HEADER_TBS_USOURCE = 'TBS-USource';
var BEAST_ID_NAME = '_mini_b';

function request(options) {
  addHeaders(options);
  console.log('mini-headers:', options);
  return (0, _axios2.default)(options);
}

function addHeaders(options) {
  var headers = options.headers = options.headers || {};

  var auth = _jsCookie2.default.get(_util.TOKEN_NAME);
  if (auth) {
    headers[HEADER_AUTHORIZATION] = auth;
  }

  var beastId = _jsCookie2.default.get(BEAST_ID_NAME);
  if (beastId) {
    headers[HEADER_BEAST_ID] = beastId;
    headers[HEADER_DEVICE_ID] = 'B-' + beastId;
  }

  headers[HEADER_PLATFORM] = (0, _browser.android)() ? 'android' : 'ios';

  if (options.header) {
    headers[HEADER_TBS_CLIENT] = options.header['tbs_client'] || 2;
    headers[HEADER_TBS_CHANNEL] = options.header['tbs_channel'] || 'CHN2078';
  } else {
    headers[HEADER_TBS_CLIENT] = 2;
    headers[HEADER_TBS_CHANNEL] = 'CHN2078';
  }

  var _getSystemInfo = getSystemInfo(),
      windowWidth = _getSystemInfo.windowWidth,
      windowHeight = _getSystemInfo.windowHeight;

  if (windowWidth && windowHeight) {
    headers.resolution = windowWidth + 'x' + windowHeight;
  }

  var uSource = _util.query[_util.TBS_USOURCE_NAME];
  if (uSource) {
    headers[HEADER_TBS_USOURCE] = uSource;
  }

  // Disable referer
  delete headers.referer;
  delete headers.Referer;
}

var info = void 0;
function getSystemInfo() {
  if (info) {
    return info;
  }
  try {
    return info = wx.getSystemInfoSync();
  } catch (e) {
    return {};
  }
}

function getBeastId() {
  var beastId = _jsCookie2.default.get(BEAST_ID_NAME);
  if (beastId) {
    return _promise2.default.resolve(beastId);
  } else {
    return request({
      url: '/app/config'
    }).then(function (_ref) {
      var data = _ref.data;

      if (data && data.beastId) {
        _jsCookie2.default.set(BEAST_ID_NAME, data.beastId, { expires: 3650 });
        return data.beastId;
      }
    }).catch(function () {
      return '';
    });
  }
}

function miniSetBeastId() {
  _util.adapter.invoke(function () {
    if (_util.adapter.env === 'miniprogram') {
      getBeastId();
    }
  });
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@beastshop/sdk/lib/request/index.js
// module id = 664
// module chunks = 0